import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { AiOutlineDisconnect } from "react-icons/ai";

const TabInactivePage: React.FC = () => {
  return (
    <Box
      className="bg-hex-gray-100"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 1.5,
        px: 3,
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: "50%",
          mb: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background:
            "linear-gradient(135deg, rgba(39, 35, 102, 0.08), rgba(145, 88, 206, 0.18))",
        }}
      >
        <AiOutlineDisconnect size={28} color="#9158CE" />
      </Box>

      <Typography
        variant="body1"
        fontWeight={600}
        color="text.primary"
        textAlign="center"
      >
        This tab has been disconnected
      </Typography>
      <Typography variant="body1" color="text.secondary" textAlign="center">
        The application is active in another browser tab. Refresh this page to
        reconnect and see the latest data.
      </Typography>

      <Button
        variant="contained"
        onClick={() => window.location.reload()}
        sx={{ mt: 1 }}
      >
        Refresh page
      </Button>
    </Box>
  );
};

export default TabInactivePage;
